import {Http} from '@angular/http';
import { Injectable } from '@angular/core';
import { constant } from 'app/app.constants';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ITripsToExport } from './trips-to-export-interface';
import { Observable } from 'rxjs';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';

export interface IFormData {
  payoridslist: number[];
  initialdate: string;
  finaldate: string;
  billingstatusid: number;
  formid: number;
  tripId: number;
}
@Injectable()
export class MyTripsGridService extends ParentService {

  private dataForGrid = new BehaviorSubject<ITripsToExport>(undefined);
  dataForGrid$ = this.dataForGrid.asObservable();

  private dataForm = new BehaviorSubject<IFormData>(null);
  dataForm$ = this.dataForm.asObservable();

  constructor(private http: Http) {
    super();
   }

  getDataForGrid(data) {
    this.dataForGrid.next(data);
  }

  getDataForm(formData) {
    this.dataForm.next(formData);
  }

  getRoleActionByModule(id) {
    return this.http.get(`${constant.URL_GETMODULEACTION}/${id}`, this.getHeader())
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/my-trips-grid/my-trips-grid.service.ts